function onOffPopup() {
  console.log("click");
  const popup = document.querySelector(".custom-addon-popup");
  if (popup.style.display == "flex") {
    popup.style.display = "none";
  } else {
    popup.style.display = "flex";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const learnMoreBtn = document.querySelector(".learn-more");
  const addonPopupClose = document.querySelector(".addonClose");
  if (learnMoreBtn) {
    learnMoreBtn.addEventListener("click", onOffPopup);
  }
  addonPopupClose.addEventListener("click", onOffPopup);

  var popupContent = document.querySelector(".popup-content");
  popupContent.addEventListener("scroll", function () {
    // console.log(popupContent.scrollTop);

    const popupCloseBtn = document.querySelector(
      ".popup-top-close.addonClose svg"
    );

    if (popupCloseBtn) {
      if (popupContent.scrollTop > 500) {
        popupCloseBtn.style.fill = "#bd4367";
      } else {
        popupCloseBtn.style.fill = "#ffffff";
      }
    } else {
      console.error("Popup close button not found.");
    }
  });
});

// let thubmImgs = document.querySelectorAll(".thumb-imgs");
// thubmImgs.forEach((element) => {
//   element.addEventListener("click", () => {
//     console.log("clicked");
//     document.querySelector(".product-first-image-img").src = element.src;
//   });
// });
